import { render } from "./PaymentDisputeTable.vue?vue&type=template&id=31782ec8"
import script from "./PaymentDisputeTable.vue?vue&type=script&lang=js"
export * from "./PaymentDisputeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle});
